let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("898NL")).then(() => parcelRequire('7F4Ut'));